import {useGoVehisService} from "../../../utils/axios";
import React, {useEffect, useState} from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TextField,
  IconButton
} from '@material-ui/core';
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import DeleteIcon from "@material-ui/icons/Delete";
import TableContainer from "@material-ui/core/TableContainer";

function ColorStandardizationList() {
  const goVehisService = useGoVehisService();

  const [colors, setColors] = useState([]);
  const [newColor, setNewColor] = useState({ token: '', standardizedColor: '' });

  useEffect(() => {
    fetchColors();
  }, []);

  const fetchColors = () => {
    goVehisService.get("/admin/colors").then(
      res => { setColors(res.data); }
    );
  };

  const handleAddColor = () => {
    if (!newColor.token || !newColor.standardizedColor) {
      alert("Proszę wypełnić oba pola");
      return;
    }
    goVehisService.post("/admin/colors", newColor).then(() => {
      setNewColor({ token: '', standardizedColor: '' });
      fetchColors();
    });
  };

  const handleDeleteColor = (token) => {
    if (window.confirm("Czy na pewno chcesz usunąć to mapowanie?")) {
      goVehisService.delete(`/admin/colors/${token}`).then(() => {
        fetchColors();
      });
    }
  };

  return (
    <Box p={3}>
      <Box mb={3} display="flex" alignItems="center">
        <TextField
          label="Token"
          variant="outlined"
          size="small"
          value={newColor.token}
          onChange={(e) => setNewColor({ ...newColor, token: e.target.value })}
          style={{ marginRight: 10 }}
        />
        <TextField
          label="Standardowy kolor"
          variant="outlined"
          size="small"
          value={newColor.standardizedColor}
          onChange={(e) => setNewColor({ ...newColor, standardizedColor: e.target.value })}
          style={{ marginRight: 10 }}
        />
        <Button variant="contained" color="primary" onClick={handleAddColor}>
          Dodaj / Aktualizuj
        </Button>
      </Box>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Token</TableCell>
              <TableCell>Standardowy kolor</TableCell>
              <TableCell align="right">Akcje</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {colors.map((color) => (
              <TableRow key={color.token}>
                <TableCell>{color.token}</TableCell>
                <TableCell>{color.standardizedColor}</TableCell>
                <TableCell align="right">
                  <IconButton onClick={() => handleDeleteColor(color.token)} color="secondary">
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default ColorStandardizationList;
